
import { Component, Prop, Emit, Inject, Vue } from 'vue-property-decorator';
import ImagesPreview from '../Generics/Images/ImagesPreview.vue'
import { formatDate } from '../../utils/date-handlers';
import { Note } from '../../../shared/types/notes/notes';
import { InjectionKey } from '../../injection-keys';
import { TenantConfig } from '../../../tenants/types';

@Component({
  components: {
    ImagesPreview
  }
})
export default class ModalNoteInfoMap extends Vue {
  @Prop() visible: boolean;
  @Prop({ default: null }) noteInfo: Note | any;
  @Inject({ from: InjectionKey.Tenant, default: null }) readonly tenant!: TenantConfig | null;

  /** Autor de la nota (`user_name`) según `features.noteAuthor`. */
  get showAuthor(): boolean {
    return !!this.tenant && this.tenant.features.noteAuthor;
  }

  /** Badges only when notes were enriched under CLAIM privilege */
  get showSamplingBadges(): boolean {
    return !!(
      this.noteInfo &&
      this.noteInfo.sampling != null &&
      Object.prototype.hasOwnProperty.call(this.noteInfo, 'sampling_classification_name')
    );
  }

  get displayNoteText(): string {
    const text = this.noteInfo && this.noteInfo.text;
    return text != null && String(text).trim() !== '' ? text : '-';
  }

  get muestraChipStyle(): Record<string, string> {
    const color =
      (this.noteInfo && this.noteInfo.sampling_marker_color) || '#1976D2';
    return { backgroundColor: color, borderColor: color };
  }

  @Emit()
  closeModal() {}

  parseDate(date){
    return formatDate(date)
  }
}
